var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择行业分类","options":_vm.opt,"props":{value:'id',label:'title'}},model:{value:(_vm.cate_choose),callback:function ($$v) {_vm.cate_choose=$$v},expression:"cate_choose"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }